<template>
    <div class="gcmcn-card universe-event-card">
        <div class="universe-event">
            <img v-if="event.default_thumbnail" :src="event.default_thumbnail">
            <div v-else class="no-img">
                <div>No default thumbnail</div>
            </div>
            <div>{{ event.name }}</div>
        </div>
        <div class="see-more-link" @click="showEvent">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>

export default {

    components: {
    },

    props: {
        event: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {
        };
    },

    computed: {

    },

    mounted (){
    },

    methods: {
        showEvent (){
            this.$router.push({
                name: 'events',
                params: { eventUid: this.event.uid }
            });
        },
    },
};
</script>

<style lang="scss">
.universe-event-card{
    margin-bottom: 20px;
    .universe-event{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .no-img{
            width: 104px;
            height: 59px;
            background-color: #161617;
            color: #bbb;
            font-weight: bold;
            text-transform: uppercase;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-size: 10px;
        }
        img{
            width: 104px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Universes/event.vue